import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { MotifButton, MotifTextLink, MotifIcon, MotifChip } from '@ey-xd/motif-react';
import { useRecoilState, useRecoilValue } from 'recoil';
import {
  Current_User,
  Recoil_Gcsp_Quarter_State,
  Recoil_Selected_Account_State,
} from '../../../../recoil/recoil';
import { actionIcLaunch24px } from '@ey-xd/motif-react/assets/icons';
import {
  subHeaderGCSPPastQtrDetails,
  subHeaderGCSPPastMonthDetails,
} from '../../../../services/gcspServices';
import {
  SubHeaderContainer,
  SubmitButtonContainer,
  Hyperlink,
  QuarterTitle,
  QuarterDates,
  HyperlinkText,
  Divider,
} from '../../../atoms/subHeaderText/subHeader.styles';
import { BUTTON_TITLE, abbreviatedMonthList } from '../../../../constants/commonConstants';
import { structureMonth } from '../../../../util/commonUtil';

const PastSubHeaderGcsp = props => {
  const navigate = useNavigate();
  const [subHeaderData, setSubHeaderData] = useState([]);
  const [quarterData, setQuarterData] = useRecoilState(Recoil_Gcsp_Quarter_State);
  const [selectedAccount, setSelectedAccount] = useRecoilState(Recoil_Selected_Account_State);
  const currentUser = useRecoilValue(Current_User);

  let MONTH = props.month;
  let YEAR = props.year;
  let forecast_type = props.forecast_type;
  let QUARTER = props.quarter;
  const fetchDateRange = async () => {
    try {
      let data = await (forecast_type === 'quarter'
        ? subHeaderGCSPPastQtrDetails(QUARTER, YEAR, currentUser.email)
        : subHeaderGCSPPastMonthDetails(QUARTER, MONTH, YEAR, currentUser.email));
      setSubHeaderData(data);
    } catch (error) {
      console.error('Error fetching forecast submit status:', error);
    }
  };

  useEffect(() => {
    fetchDateRange();
  }, [forecast_type, MONTH, YEAR, QUARTER, currentUser]);

  const formatDate = date => {
    const month_array = abbreviatedMonthList;
    let d = new Date(date);
    let day = d.getDate();
    let month = month_array[d.getMonth()];
    let year = d.getFullYear();
    return `${month} ${day}, ${year}`;
  };
  let start_date;
  let end_date;
  if (subHeaderData.length !== 0) {
    let keys = Object.keys(subHeaderData);
    start_date = subHeaderData[keys[0]].start_date;
    end_date = subHeaderData[keys[keys.length - 1]].end_date;
    start_date = formatDate(start_date);
    end_date = formatDate(end_date);
  }

  const fullMonth = MONTH ? structureMonth(MONTH) : '';
  const quarter = QUARTER.charAt(1);

  const renderQuarterInfo = () => {
    if (setSubHeaderData.length !== 0) {
      return (
        <>
          <QuarterTitle>
            {forecast_type === 'quarter'
              ? `Quarter ${quarter} FY ${YEAR}`
              : `${fullMonth} FY ${YEAR}`}
          </QuarterTitle>
        </>
      );
    }
  };

  return (
    <SubHeaderContainer>
      {renderQuarterInfo()}
      <SubmitButtonContainer>
        <Hyperlink>
          <MotifTextLink
            variant="alt"
            href={
              selectedAccount &&
              `${process.env.REACT_APP_ACCOUNT_LENS_URL}app/dashboard/pipeline/${selectedAccount.ey_dunsnumber}`
            }
            target="_blank"
          >
            <MotifIcon src={actionIcLaunch24px} />
            <HyperlinkText>View Account in LENS</HyperlinkText>
          </MotifTextLink>
        </Hyperlink>
        <Hyperlink>
          <MotifTextLink
            variant="alt"
            href={
              selectedAccount &&
              `${process.env.REACT_APP_OPPS_NAME_IFRAME_URL}/main.aspx?appid=${process.env.REACT_APP_OPP_NAME_URL_APP_ID}&forceUCI=1&pagetype=entityrecord&etn=account&id=${selectedAccount.account_id}`
            }
            target="_blank"
          >
            <MotifIcon src={actionIcLaunch24px} />
            <HyperlinkText>View Opportunites in EY CRM</HyperlinkText>
          </MotifTextLink>
        </Hyperlink>

        <Divider />
        <MotifButton
          variant="secondary"
          className="submitButton"
          onClick={() => {
            navigate('/');
          }}
        >
          {BUTTON_TITLE.CLOSE}
        </MotifButton>
      </SubmitButtonContainer>
    </SubHeaderContainer>
  );
};

export default PastSubHeaderGcsp;
